const Testimonialdetails =[
{
    id:1,
    name:"Jayaprashanth",
    designation:"COO - Fleet Management, Mobility & IOT Solutions",
    description:"I would say that the whole modules in this product precisely automated my procurement & supply chain functional flow and I no longer need to worry about tracking my vendor's various supply chain functions. Vendora helped us to Track the vendor performance by various attributes to track the vendor efficiency. Various reports in the buyer and vendor dashboard display is a heads up to act accordingly.",

},
{
    id:2,
    name:"Kamal",
    designation:"Assistant Manager - Consumer Goods Manufacturer",
    description:"Easy to use system, good product development team, Made procurement team life easy. Over all good and easy to use product, very simple and has user friendly forms, reports and dashboard.",

},
{
    id:3,
    name:"Ajeesh ",
    designation:"Strategic Sourcing - Electrical/Electronic Manufacturing",
    description:"All the major activities related to Vendor is coming under one platform which includes multiple vendor modules. Over all it is a good solution for managing vendors and our suppliers. Simple and it is user friendly for all users. The forms, reports and dashboard are good.",

},
{
    id:4,
    name:"Sandeep ",
    designation:"Costing and Analytics Manager - Consumer Goods Manufacturer",
    description:"The design is very flexible and can be modified. The vision of the creator is very good. Fully scalable and adaptable. User friendly features and forms with custom reporting dashboard facility.",

},
]

export default Testimonialdetails;